// extracted by mini-css-extract-plugin
module.exports = {"container":"FirstChild_container__25hcD","headline":"FirstChild_headline__juKG3"};